import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {SharedModule} from './shared/shared.module';
import {OverviewComponent} from './containers/overview/overview.component';
import {EntitySummaryComponent} from './containers/entity-summary/entity-summary.component';
import {CounterPartyComponent} from './containers/counter-party/counter-party.component';
import {NgChartsModule} from 'ng2-charts';
import {AgGridModule} from 'ag-grid-angular';
import {SuperAdminGuard} from './shared/super-admin.guard';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {UserProfileResolverService} from '../core/services/user-profile-resolver.service';
import {UtilityService} from '../core/services/utility.service';
import {ApplicationEventsService} from '../core/services/application-events.service';
import {VisualisationsComponent} from './containers/visualisations/visualisations.component';
import { AppNavComponent } from '../layout/components/app-nav/app-nav.component';
import { AppModule } from '../app.module';
import {AuthGuardService, SsjsauthcallbackComponent,SsjslogoutComponent} from '@frmk2sjs/services';

export const ROUTES: Routes = [
    {path: '', pathMatch: 'full', redirectTo: 'overview'},
    {
        path: 'auth-callback',
        component: SsjsauthcallbackComponent,
    },
    {
        path: 'logout',
        component: SsjslogoutComponent,
    },
    {path: 'overview',
    canActivate: [AuthGuardService],
    component: OverviewComponent, resolve: {user: UserProfileResolverService}},
    {
        path: 'visualisations',
        canActivate: [AuthGuardService, SuperAdminGuard],
        component: VisualisationsComponent,
        resolve: {user: UserProfileResolverService}
    },
    {
        path: 'entitySummary/:entityId',
        component: EntitySummaryComponent,
        resolve: {user: UserProfileResolverService}
    },
    {
        path: 'counterParty/:entityId/:counterPartyId',
        component: CounterPartyComponent,
        resolve: {user: UserProfileResolverService}
    }
];

@NgModule({
    imports: [
        RouterModule.forChild(ROUTES),
        SharedModule.forRoot(),
        NgChartsModule,
        AgGridModule,
        FormsModule,
        NgbModule,
        ReactiveFormsModule,
        CommonModule
    ],
    exports: [/*AppNavComponent*/],
    declarations: [
        OverviewComponent,
        EntitySummaryComponent,
        CounterPartyComponent,
        VisualisationsComponent,
        //AppNavComponent
    ],
    providers: [
        UserProfileResolverService,
        UtilityService,
        ApplicationEventsService,
        SuperAdminGuard
    ]
})
export class DnaModule {
}
